import catalogService from "../../../services/catalog/catalog.service";
import { catalogActionTypes } from "../../actionTypes/catalog/catalog.actionTypes";

export const exportCatalogByItems = (itemIds) => async (dispatch) => {
  try {
    dispatch({ type: catalogActionTypes.START_EXPORT_CATALOG_BY_ITEMS });
    await catalogService.exportCatalogByItems(itemIds);
    dispatch({ type: catalogActionTypes.EXPORT_CATALOG_BY_ITEMS_SUCCESS });
    return { success: true };
  } catch (error) {
    console.error("Export catalog by items error:", error);
    dispatch({
      type: catalogActionTypes.EXPORT_CATALOG_BY_ITEMS_FAILURE,
      error: error.response?.data || error.message,
    });
    throw error;
  }
};

export const exportCatalogByCategories = (categoryIds) => async (dispatch) => {
  try {
    dispatch({ type: catalogActionTypes.START_EXPORT_CATALOG_BY_CATEGORIES });
    await catalogService.exportCatalogByCategories(categoryIds);
    dispatch({ type: catalogActionTypes.EXPORT_CATALOG_BY_CATEGORIES_SUCCESS });
    return { success: true };
  } catch (error) {
    console.error("Export catalog by categories error:", error);
    dispatch({
      type: catalogActionTypes.EXPORT_CATALOG_BY_CATEGORIES_FAILURE,
      error: error.response?.data || error.message,
    });
    throw error;
  }
};

export const exportCatalogByItemGroups = (itemGroupIds) => async (dispatch) => {
  try {
    dispatch({ type: catalogActionTypes.START_EXPORT_CATALOG_BY_ITEM_GROUPS });
    await catalogService.exportCatalogByItemGroups(itemGroupIds);
    dispatch({ type: catalogActionTypes.EXPORT_CATALOG_BY_ITEM_GROUPS_SUCCESS });
    return { success: true };
  } catch (error) {
    console.error("Export catalog by item groups error:", error);
    dispatch({
      type: catalogActionTypes.EXPORT_CATALOG_BY_ITEM_GROUPS_FAILURE,
      error: error.response?.data || error.message,
    });
    throw error;
  }
};

const catalogActions = {
  exportCatalogByItems,
  exportCatalogByCategories,
  exportCatalogByItemGroups,
};

export default catalogActions;

